import $ from "jquery";

const headerHeight = $("header").outerHeight();

$(".go-to-products").on("click", function (e) {
    $(this).removeAttr("href");

    $("html, body").animate(
        {
            scrollTop: $(".section-products").offset().top - headerHeight,
        },
        500,
    );
});

$(".go-to-footer").on("click", function (e) {
    $(this).removeAttr("href");

    $("html, body").animate(
        {
            scrollTop: $(".section-footer").offset().top - headerHeight,
        },
        500,
    );
});
